import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MarketService } from '@http/clients/reporting-app/market.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-market-form-editor',
    templateUrl: './report-market-form-editor.component.html',
    styleUrls: ['./report-market-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportMarketFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportMarketFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Markets');
    placeholderText = input<string>('Select Markets');

    private readonly marketService = inject(MarketService);

    async ngOnInit(): Promise<void> {
        const markets = await this.marketService.getAll();
        this.items.set(markets);
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(value: number[] | null): any[] {
        if (!value?.length) return [];
        const selectedIds = new Set(value.map((id) => Number(id)));
        return (this.items() ?? []).filter((item) => selectedIds.has(Number(item.id)));
    }
}
